var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.674,
    height: 122.673,
    viewBox: "0 0 122.674 122.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-blocks-4264756",
    transform: "translate(-125.995 -55.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M388.39,329.9v15.757A11.525,11.525,0,0,0,399.9,357.168h15.757a11.525,11.525,0,0,0,11.511-11.512V329.9a11.525,11.525,0,0,0-11.511-11.512H399.9A11.525,11.525,0,0,0,388.39,329.9Zm35.715,0v15.757a8.455,8.455,0,0,1-8.445,8.446H399.9a8.455,8.455,0,0,1-8.445-8.446V329.9a8.455,8.455,0,0,1,8.445-8.446H415.66A8.455,8.455,0,0,1,424.1,329.9Z",
    transform: "translate(-190.545 -190.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M247.136,115.8H218.768V57.532A1.534,1.534,0,0,0,217.234,56h-59.8a1.533,1.533,0,0,0-1.534,1.534V115.8H127.529A1.533,1.533,0,0,0,126,117.335v59.8a1.534,1.534,0,0,0,1.534,1.534H247.136a1.533,1.533,0,0,0,1.534-1.534v-59.8a1.534,1.534,0,0,0-1.534-1.534ZM158.965,59.066H215.7V115.8H158.965Zm-29.9,59.8H185.8v56.736H129.063ZM245.6,175.605H188.867V118.869H245.6Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M189.378,318.39a19.391,19.391,0,1,0,19.39,19.39A19.413,19.413,0,0,0,189.378,318.39Zm0,35.715A16.324,16.324,0,1,1,205.7,337.78,16.342,16.342,0,0,1,189.378,354.1Z",
    transform: "translate(-31.946 -190.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M299.409,134.05l17.832-10.294a1.532,1.532,0,0,0,.767-1.328V101.838a1.534,1.534,0,0,0-.767-1.328L299.409,90.215a1.54,1.54,0,0,0-1.534,0l-17.832,10.294a1.532,1.532,0,0,0-.767,1.328v20.59a1.534,1.534,0,0,0,.767,1.328l17.832,10.293a1.535,1.535,0,0,0,1.534,0Zm-17.065-12.507v-18.82l16.3-9.408,16.3,9.408v18.82l-16.3,9.409Z",
    transform: "translate(-111.309 -24.699)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.e3e2c5768eb33a0f172f583c9a55b3d6.svg";
export { ForwardRef as ReactComponent };